import { jsx as i, jsxs as l } from "react/jsx-runtime";
import { Badge as x } from "@mui/material";
import { useSideNav as h } from "./useSideNav2.mjs";
import { isDefined as p } from "./types3.mjs";
import { ListItem as $, ListItemButton as v, ListItemIcon as s, ListItemText as I, BadgeInline as f } from "./styles91.mjs";
const S = ({
  icon: a,
  title: t,
  isActive: e,
  onClick: n,
  component: m,
  badgeContent: d,
  badgeColor: o,
  ...c
}) => {
  const { isExpanded: r } = h();
  return /* @__PURE__ */ i($, { disablePadding: !0, children: /* @__PURE__ */ l(
    v,
    {
      ...c,
      component: m,
      onClick: n,
      $isExpanded: r,
      $isActive: e,
      children: [
        p(d) && !r ? /* @__PURE__ */ i(
          x,
          {
            variant: "dot",
            color: o,
            badgeContent: d,
            overlap: "circular",
            children: /* @__PURE__ */ i(s, { $isExpanded: r, $isActive: e, children: a })
          }
        ) : /* @__PURE__ */ i(s, { $isExpanded: r, $isActive: e, children: a }),
        /* @__PURE__ */ i(
          I,
          {
            $isExpanded: r,
            $isActive: e,
            primaryTypographyProps: {
              variant: "body2",
              whiteSpace: "nowrap",
              noWrap: !0
            },
            primary: t,
            children: t
          }
        ),
        p(d) && r && /* @__PURE__ */ i(
          f,
          {
            variant: "standard",
            color: o,
            badgeContent: d
          }
        )
      ]
    }
  ) });
};
export {
  S as SideNavItem
};
//# sourceMappingURL=index125.mjs.map
